import * as React from 'react';

const PackageQuantityItem = ({ label , subtext , aside , className  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: `${className}__content`
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${className}__quantity`
    }, /*#__PURE__*/ React.createElement("span", {
        className: `${className}__amount`
    }, label), subtext && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__subtext`
    }, subtext)), aside && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__aside`
    }, aside));
};

export { PackageQuantityItem };
//# sourceMappingURL=PackageQuantityItem.js.map
